import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {CLIENT, CLIENT_MAINTENANCE} from '../../../constants/MicroServiceConstants';
import {
  STATE,
  CLIENT_CLASS,
  LOCATION_CODE,
  SERVICE_TYPE,
  FEE_TYPE,
} from '../../../constants/Lookup';
const initialData = {
  clientGeneralData: {},
  dropDownData: {},
  clientServiceData: {},
  clientParentData: {},
  clientName: {},
  clientCodeData: {},
  clientNameData: {},
  allClientNames: [],
  clientCodeStatus: null,
  allClientCodeData: [],
  parentClientCodeData: {},
  clientAddressData: {},
  subServiceTypes: [],
  serviceTypes: [],
  subServices: [],
  services: [],
  clientPrefixData: [],
  updatedClientCodeStatus: null,
  parentClientCodeStatus: null,
  clientGeneralStatus: null,
  isLoading: false,
  isSaveCardLoading: false,
  errorMsg: null,
  clientFetchStatus: null,
  successMsg: null,
  postRateCardStatus: null,
};

const slice = createSlice({
  name: 'clientGeneral',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchSaveCardStart: (state) => {
      state.isSaveCardLoading = true;
      state.errorMsg = null;
    },
    fetchClientGeneralData: (state, action) => {
      state.clientFetchStatus = action.payload.status;
      state.clientGeneralData = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchAllClientNameData: (state, action) => {
      state.allClientNames = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    setServiceTypes: (state, action) => {
      state.serviceTypes = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    setSubserviceTypes: (state, action) => {
      state.subServiceTypes = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchServiceValues: (state, action) => {
      state.services = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getSubservices: (state, action) => {
      state.subServices = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getclientAddressData: (state, action) => {
      state.clientAddressData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postClientGeneralData: (state, action) => {
      state.clientGeneralStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    updateClientGeneralData: (state, action) => {
      state.updatedClientCodeStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postClientCodesData: (state, action) => {
      state.clientCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchedClientCodesData: (state, action) => {
      state.allClientCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postClientNameData: (state, action) => {
      state.clientNameData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postParentClientCodesData: (state, action) => {
      state.parentClientCodeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postRateCardData: (state, action) => {
      state.postRateCardStatus = action.payload;
      state.isLoading = false;
      state.isSaveCardLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    postSubscribeService: (state, action) => {
      state.postRateCardStatus = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    getClientServiceData: (state, action) => {
      state.clientServiceData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getClientData: (state, action) => {
      state.clientData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getClientParentData: (state, action) => {
      state.clientParentData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getClientPrefixData: (state, action) => {
      state.clientPrefixData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetClientGeneral: (state) => {
      state.clientGeneralStatus = null;
      state.postRateCardStatus = null;
      state.isLoading = false;
    },
    resetUpdateClientGeneral: (state) => {
      state.updatedClientCodeStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
      state.isSaveCardLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.clientFetchStatus = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    resetClientCodesData: (state) => {
      state.clientCodeData = {};
    },
    resetClientNameData: (state) => {
      state.clientNameData = {};
    },
    resetParentClientCodesData: (state) => {
      state.parentClientCodeData = {};
    },
    resetClientAddressData: (state) => {
      state.clientAddressData = {};
    },
    resetSubServiceTypesData: (state) => {
      state.subServiceTypes = {};
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchClientGeneralData,
  fetchDropDownData,
  getclientAddressData,
  postClientCodesData,
  fetchedClientCodesData,
  postClientNameData,
  getClientData,
  postParentClientCodesData,
  resetMsg,
  postClientGeneralData,
  setSubserviceTypes,
  setServiceTypes,
  getClientServiceData,
  getClientParentData,
  updateClientGeneralData,
  fetchStart,
  resetClientGeneral,
  fetchError,
  fetchServiceValues,
  resetClientCodesData,
  resetClientNameData,
  fetchAllClientNameData,
  resetParentClientCodesData,
  resetUpdateClientGeneral,
  resetClientAddressData,
  resetSubServiceTypesData,
  postSubscribeService,
  postRateCardData,
  getClientPrefixData,
  fetchSaveCardStart,
} = slice.actions;

export const fetchClientGeneral = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT}/find/clientgeneral/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchClientGeneralData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const getClientAddress = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/parentclientaddress/${id}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getclientAddressData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchClientService = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/servicetype/lookup`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientServiceData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchServices = (val) => {
  return (dispatch) => {
    httpPost(`client/find/services`, {companyId: val})
      .then((data) => {
        if (data && data?.status && data.status === 200) {
          dispatch(fetchServiceValues(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchClientParent = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/all/parentclientname`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientParentData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchDropDowns = () => {
  return (dispatch) => {
    httpPost(`lookup/find/all/lookup`, {
      typeCode: [STATE, LOCATION_CODE, CLIENT_CLASS, SERVICE_TYPE, FEE_TYPE],
    })
      .then((response) => {
        if (response?.status && response.status === 200) {
          dispatch(fetchDropDownData(response.data));
        } else {
          dispatch(fetchError(response?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postClientGeneral = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT}/clientgeneral`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postClientGeneralData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getServiceType = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    // Find ServiceType api
    // Req Url :-  https://galaxyghidevapi.pdsnew.com/api/v1/client/find/services
    // Payload :- {
    //   "companyId": "MED-1 Solutions, LLC",
    //   "parentClientId": "12"
    // }
    httpPost(`${CLIENT}/find/services`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setServiceTypes(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const getSubServiceTypes = (payload, callback) => {
  return (dispatch) => {
    dispatch(fetchStart());
    // Find SubServiceType api
    // Req Url:- https://galaxyghidevapi.pdsnew.com/api/v1/client/find/sub/servicetype/{ServiceTypeId}
    httpPost(`${CLIENT}/find/sub/servicetype `, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(setSubserviceTypes(data.response));
          callback(data.response);
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const updateClientGeneral = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT}/update/clientgeneral`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(updateClientGeneralData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postClientCode = (data) => {
  return (dispatch) => {
    httpPost(`${CLIENT}/search/clientnumber`, data, {})
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(postClientCodesData(data.response));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchAllClientCodes = (data) => {
  return (dispatch) => {
    httpPost(`${CLIENT}/search/clientnumber`, data, {})
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(fetchedClientCodesData(data.response));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postClientName = (data) => {
  return (dispatch) => {
    httpPost(`${CLIENT_MAINTENANCE}/search/clientname`, data, {})
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(postClientNameData(data.response));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchSearchClientName = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/all/clientname`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientData(data.response));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchAllClientName = (data) => {
  return (dispatch) => {
    httpPost(`${CLIENT_MAINTENANCE}/search/clientname`, data, {})
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(fetchAllClientNameData(data?.response));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const saveRateCard = (payload) => {
  return (dispatch) => {
    dispatch(fetchSaveCardStart());
    httpPost(`client/save/client/ratecard`, payload, {})
      .then((data) => {
        if (data?.data?.status === 400 || data?.data?.status === 500) {
          dispatch(fetchError(data?.data?.message));
        } else if (data?.status && data.status === 200) {
          dispatch(postRateCardData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postSubscribeServiceData = (payload) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT}/save/subscribe `, payload, {})
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(postSubscribeService(data));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postParentClientCode = (data) => {
  return (dispatch) => {
    httpPost(`${CLIENT}/search/clientnumberparent`, data, {})
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(postParentClientCodesData(data.response));
        } else {
          dispatch(fetchError(data?.response?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchClientPrefix = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/all/clientprefix`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientPrefixData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetClientGeneral());
  };
};
export const resetUpdateStatus = () => {
  return (dispatch) => {
    dispatch(resetUpdateClientGeneral());
  };
};
export const resetClientCodes = () => {
  return (dispatch) => {
    dispatch(resetClientCodesData());
  };
};
export const resetNameCodes = () => {
  return (dispatch) => {
    dispatch(resetClientNameData());
  };
};
export const resetParentClientCodes = () => {
  return (dispatch) => {
    dispatch(resetParentClientCodesData());
  };
};
export const resetClientAddress = () => {
  return (dispatch) => {
    dispatch(resetClientAddressData());
  };
};
export const resetSubServiceTypes = () => {
  return (dispatch) => {
    dispatch(resetSubServiceTypesData());
  };
};
